import { useTranslation } from '@/contexts/i18n-context';
import { ErrorLayout } from '@/components/error-layout';

export function SystemErrorPage() {
  const { t } = useTranslation();

  return <ErrorLayout title={t('systemError.title')} description={t('systemError.description')} />;
}
